<div class="max-w-3xl mx-auto px-4 py-6 space-y-4">
  <tt-alert
    variant="danger"
    [label]="(textService.get('error.title') | async) ?? ''"
    [message]="(textService.get('error.text') | async) ?? ''"
  />
  <tt-button variant="primary" (clicked)="retry()">
    {{ textService.get('error.try-again') | async }}
  </tt-button>
</div>
